import React, {FC} from 'react'
import classnames from 'classnames'
import StylesType from '@/types/StylesType'
import {Row, Col} from 'antd'
import report from '@/utils/log'

import './style/FileopearButtons.less'
import Button from '@/components/Button'
import Icon from '@/components/Icon'
import {SelectIndexType} from "@/stores/base/UploadStore";

interface FileOpearButtonsTypes{
  uploadBegin: (file: any) => any
  getFile: (e: any) => void
  clearHistory?: () => void
  selectIndex: SelectIndexType;
  clickUpload?: () => void
}

type FileOpearButtonsProps = StylesType & FileOpearButtonsTypes

const FileOpearButtons: FC<FileOpearButtonsProps> = props => {
  const {prefixCls = 'gc_', className, getFile, clearHistory, selectIndex, clickUpload} = props

  const onClickClearHistory = () => {
    // 点击上传记录 事件上报
    report({
      eventId: 'E0502',
      pageId: 'P05',
      ext: '',
    })

    clearHistory&&clearHistory()
  }


  return (
    <Row type='flex' align='middle' gutter={[20, 0]}
         className={classnames(prefixCls + 'file_opear_buttons', className)}>
      <Col onClick={clickUpload}>
        <Button type="primary"><Icon type='iconshangchuanwenjian1'/>上传
          <input type='file' name='file' id='upload' onChange={(e)=>getFile(e)} className={classnames('upload')}/>
        </Button>
      </Col>
      {
        selectIndex === 3 && <Col><Button type="primary" ghost onClick={onClickClearHistory}><Icon type='iconshanchuzu'/>清楚记录</Button></Col>
      }
    </Row>
  )
}
export default FileOpearButtons
